import type { Role } from '../types/api';

// Access token lives in memory only — never touches disk.
let _accessToken: string | null = null;

export const getAccessToken  = () => _accessToken;
export const getRefreshToken = () => localStorage.getItem('cadence_refresh');

export interface StoredUser {
  id: string;
  name: string;
  email: string;
  role: Role;
  permissions: string[];
}

export function getStoredUser(): StoredUser | null {
  const raw = localStorage.getItem('cadence_user');
  return raw ? (JSON.parse(raw) as StoredUser) : null;
}

export function setTokens(access: string, refresh: string) {
  _accessToken = access;
  localStorage.setItem('cadence_refresh', refresh);
}

export function setStoredUser(user: StoredUser) {
  localStorage.setItem('cadence_user', JSON.stringify(user));
}

export function clearTokens() {
  _accessToken = null;
  localStorage.removeItem('cadence_refresh');
  localStorage.removeItem('cadence_user');
}

export function parseTokenClaims(token: string): {
  sub: string;
  role: string;
  engineerId: string | null;
  exp: number;
} {
  const payload = JSON.parse(atob(token.split('.')[1]));
  return {
    sub:        payload.sub        as string,
    role:       payload.role       as string,
    engineerId: payload.engineerId as string | null ?? null,
    exp:        payload.exp        as number,
  };
}

const ROLE_RANK: Record<Role, number> = {
  engineer:        0,
  team_lead:       1,
  product_manager: 2,
  project_manager: 3,
  head_of_rd:      4,
};

export function hasRole(userRole: Role, minRole: Role): boolean {
  return ROLE_RANK[userRole] >= ROLE_RANK[minRole];
}
